import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import { useEffect, useState } from 'react'

import { operationCheckRequested, operationReconcileRequested } from './commands'
import type { RmkVm } from './types'

/** Пока кабинет подтверждает нашу команду, сверяем её без повторной отправки команды кассе. */
export function useShiftProgress(vm: RmkVm, dispatch: Dispatch<UnknownAction>): number | null {
  const [scheduled, setScheduled] = useState<{ operationId: string; at: number } | null>(null)
  const operation = vm.operation
  const active = operation !== null && operation.canCheck && !operation.checking && !operation.reconciling && operation.phase !== 'settled'
  useEffect(() => {
    if (!active || operation === null) return undefined
    const schedule = () => setScheduled({ operationId: operation.operationId, at: Date.now() + 10_000 })
    schedule()
    const timer = setInterval(() => {
      if (document.visibilityState !== 'visible') return
      schedule()
      if (operation.manualRequired || operation.version === null || !operation.canReconcile) {
        dispatch(operationCheckRequested({ resourceId: vm.resourceId, registerKey: operation.registerKey, operationId: operation.operationId }))
        return
      }
      dispatch(operationReconcileRequested({
        resourceId: vm.resourceId,
        registerKey: operation.registerKey,
        operationId: operation.operationId,
        expectedVersion: operation.version,
      }))
    // Страховка: о смене статуса команды кабинет сообщает вебхуком, окно перечитывает по живому событию aqsi.operation.changed.
    }, 10_000)
    return () => clearInterval(timer)
  }, [active, dispatch, operation, vm.resourceId])
  return active && scheduled?.operationId === operation?.operationId ? scheduled?.at ?? null : null
}
